import React, { FC } from 'react';
import styles from './styles.module.css';
import { Switch, RouteComponentProps, Route } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import {
  RewardsPortal,
  SpinWheel,
  TwentySixForTwentySix,
} from 'Rewards/screens';
import { env } from 'Shared/constants/env';
import { Loading } from 'Shared/components/Loading';
import { useRewardsEnrollmentContext } from 'Shared/providers/RewardsEnrollmentProvider';

export const Router: FC<RouteComponentProps> = ({ match }) => {
  const spinEnabled = env.rewardsSpinEnabled;
  const { source, loading } = useRewardsEnrollmentContext();

  // No-flicker: while the provider is still resolving (kill switch ON),
  // render Loading rather than falling through to RewardsPortal.
  const showLoading = spinEnabled && loading;
  const enrolled26For26 = spinEnabled && source === '26for26';

  return (
    <div
      className={enrolled26For26 ? styles.containerNoPadding : styles.container}
    >
      <AnimatePresence mode="wait">
        {showLoading ? (
          <Loading key="loading" />
        ) : (
          <Switch key="routes">
            {spinEnabled && (
              <Route
                path={`${match.url}/spin`}
                component={SpinWheel}
                key="spinWheel"
              />
            )}
            {enrolled26For26 ? (
              <Route
                path={match.url}
                component={TwentySixForTwentySix}
                key="26for26"
              />
            ) : (
              <Route
                path={match.url}
                component={RewardsPortal}
                key="rewardsPortal"
              />
            )}
          </Switch>
        )}
      </AnimatePresence>
    </div>
  );
};
